var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 19.333V18.4997C16.0007 17.7336 16.6234 17.1108 17.3895 17.1108H17.6673V16.833C17.6673 16.3736 18.0412 15.9997 18.5007 15.9997H20.1673C20.6268 15.9997 21.0007 16.3736 21.0007 16.833V17.1108H21.2784C22.0445 17.1108 22.6673 17.7336 22.6673 18.4997V19.333H16.0007ZM19.8895 20.4441V20.9997H18.7784V20.4441H16.0007V22.6663H22.6673V20.4441H19.8895ZM14.8895 22.6663H9.33398V10.9997C9.33398 10.0808 10.0818 9.33301 11.0007 9.33301H16.5562C17.4751 9.33301 18.2229 10.0808 18.2229 10.9997V14.9097C17.5329 15.0091 16.9584 15.4702 16.7012 16.0963C15.6562 16.3958 14.8895 17.3597 14.8895 18.4997V22.6663ZM14.334 13.2219H16.0007V12.1108H14.334V13.2219ZM14.334 15.4441H16.0007V14.333H14.334V15.4441ZM13.2229 18.7775H11.5562V19.8886H13.2229V18.7775ZM13.2229 16.5552H11.5562V17.6663H13.2229V16.5552ZM13.2229 14.333H11.5562V15.4441H13.2229V14.333ZM13.2229 12.1108H11.5562V13.2219H13.2229V12.1108Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporate);
export default __webpack_public_path__ + "static/media/corporate.bcf5091eccb1d3c43d37171698d85afd.svg";
export { ForwardRef as ReactComponent };